import { connect } from 'react-redux'
import { getUserRole } from '../../redux/user/selectors'
import RouteSettings from '../../routes/settings'

const mapStateToProps = (state) => ({
  userRole: getUserRole(state),
})

export default connect(mapStateToProps, null)(RouteSettings)
